module.exports = __webpack_public_path__ + "static/media/lifetime.7adeb749.png";